import { render, staticRenderFns } from "./DashboardTrainningList.vue?vue&type=template&id=65ca5627&scoped=true&"
import script from "./DashboardTrainningList.vue?vue&type=script&lang=js&"
export * from "./DashboardTrainningList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTrainningList.vue?vue&type=style&index=0&id=65ca5627&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ca5627",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DashboardCard: require('/workspace/components/Dashboard/DashboardCard.vue').default})
